import React, { useState } from 'react';
import { MdCheckCircle } from 'react-icons/md';
import CustomerGdprData from './components/CustomerGdprData/';
import CustomerGdprForm from './components/CustomerGdprForm/';
import MiseGdprData from './components/MiseGdprData/';
import MiseGdprForm from './components/MiseGdprForm/';
import s from './Gprd.module.scss';

const Gdpr = ({
  uploadData: { gdpr, status, selectedSuppliers, id },
  uploadData,
  deleteSingleUpload,
  initialValues
}) => {
  const [openPanel, setOpenPanel] = useState('customer');

  const toggle = (panel) => {
    setOpenPanel(prev => (prev === panel ? null : panel));
  };

  if (!gdpr?.hasPersonalDetails) {
    return (
      <div className={s['gdpr-section']}>
        <h1 className={s['gdpr-section__header']}>GDPR</h1>
        <span>Ingen GDPR-data behöver granskas för denna sändning.</span>
      </div>
    );
  }

  return (
    <div className={s['gdpr-section']}>
      <h1 className={s['gdpr-section__header']}>GDPR</h1>

      <div className={s['accordion']}>
        <button
          type="button"
          className={s['accordion__header']}
          onClick={() => toggle('customer')}
          aria-expanded={openPanel === 'customer'}
        >
          <span>GDPR-info från kund</span>
          {(status === 'Approved' || status === 'Complete') && (
            <MdCheckCircle className={`${s.icon} ${s['icon--approved']}`} />
          )}
        </button>
        {openPanel === 'customer' && (
          <div className={s['accordion__content']}>
            {status === 'New' ? (
              <CustomerGdprForm
                s={s}
                uploadData={uploadData}
                initialValues={initialValues}
                deleteSingleUpload={deleteSingleUpload}
                deliveryId={id}
              />
            ) : (
              <CustomerGdprData gdprData={gdpr} s={s} />
            )}
          </div>
        )}
      </div>

      <div className={s['accordion']}>
        <button
          type="button"
          className={s['accordion__header']}
          onClick={() => toggle('mise')}
          aria-expanded={openPanel === 'mise'}
        >
          <span>GDPR-info från MISE</span>
          {status === 'Complete' && (
            <MdCheckCircle className={`${s.icon} ${s['icon--approved']}`} />
          )}
        </button>
        {openPanel === 'mise' && (
          <div className={s['accordion__content']}>
            {status === 'Approved' && <MiseGdprForm id={id} s={s} />}
            {status !== 'Complete' && <MiseGdprData suppliers={selectedSuppliers} />}
            {status === 'Complete' && <MiseGdprData suppliers={selectedSuppliers} />}
          </div>
        )}
      </div>
    </div>
  );
};

export default Gdpr;
